/**
 * Canonical order + display labels for the seven job categories.
 * Shared by the header mega-menu and the /browse/$slug category pages
 * so they can't drift.
 *
 * Internal tuple/object carry tight types (readonly `as const` literal
 * union + `satisfies`) so adding a new slug without a matching label —
 * or vice versa — is a compile error. The public exports keep the
 * looser runtime types (`string[]` / `Record<string, string>`) so
 * consumers can index them with untrusted `JobCategoryWithTags.slug`
 * values without fighting literal-union narrowing.
 */
const CATEGORY_ORDER_CANONICAL = [
  "positions",
  "skills",
  "seniority-level",
  "cloud-stack",
  "work-options",
  "industry",
  "job-type",
] as const;

type CategorySlug = (typeof CATEGORY_ORDER_CANONICAL)[number];

const CATEGORY_LABELS_CANONICAL = {
  positions: "Positions",
  skills: "Skills",
  "seniority-level": "Seniority",
  "cloud-stack": "Cloud Stack",
  "work-options": "Work Options",
  industry: "Industry",
  "job-type": "Job Type",
} satisfies Record<CategorySlug, string>;

export const CATEGORY_ORDER: string[] = [...CATEGORY_ORDER_CANONICAL];
export const CATEGORY_LABELS: Record<string, string> =
  CATEGORY_LABELS_CANONICAL;
